export const encodeURLWithParams = (url: string, params: object) => {
  const encodedParams = Object.entries(params).map(
    ([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
  ).join("&");
  return `${url}?${encodedParams}`;
};